import { render, staticRenderFns } from "./page-index.vue?vue&type=template&id=e98cbd24&scoped=true&"
import script from "./page-index.vue?vue&type=script&lang=ts&"
export * from "./page-index.vue?vue&type=script&lang=ts&"
import style0 from "./page-index.vue?vue&type=style&index=0&id=e98cbd24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98cbd24",
  null
  
)

/* custom blocks */
import block0 from "./page-index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports